import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem(useJwt.jwtConfig.userDataKeyName)
}

export const getUserData = () => JSON.parse(localStorage.getItem(useJwt.jwtConfig.userDataKeyName))
export const setUserData = data => {
  localStorage.setItem(useJwt.jwtConfig.userDataKeyName, JSON.stringify(data))
}
export const removeUserData = () => {
  localStorage.removeItem(useJwt.jwtConfig.userDataKeyName)
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return { name: 'select-community' }
  return { name: 'select-community' }
}

export const abilityResolver = role => {
  switch (role) {
    case 'admin':
      return [
        {
          action: 'manage',
          subject: 'all',
        },
      ]
    case 'dispatch':
      return [
        {
          action: 'read',
          subject: 'Public',
        },
        {
          action: 'read',
          subject: 'Dispatch',
        },
      ]
    case 'employee':
      return [
        {
          action: 'read',
          subject: 'Public',
        },
        {
          action: 'read',
          subject: 'Employee',
        },
      ]
    default:
      return initialAbility
  }
}

// eslint-disable-next-line func-names
export const logout = async function (redirect = true) {
  // Revoke the server-side session (Redis-cached Discord tokens + cookie).
  // Best-effort: still clear local state and redirect even if this fails.
  try {
    await this.$http.post('/auth/logout')
  } catch {
    // ignore — proceed to clear local state regardless
  }

  // Remove userData from localStorage
  removeUserData()

  // Reset ability
  this.$ability.update(initialAbility)

  // Reset store
  this.$store.dispatch('selection/SELECT_COMMUNITY', null)
  this.$store.dispatch('selection/SELECT_SERVICE', null)

  // Disconnect socket
  this.$socket.client.close()

  if (!redirect) return

  // Redirect to login page
  this.$router.push({ name: 'login' })
}

// eslint-disable-next-line func-names
export const connectSocket = function () {
  if (!isUserLoggedIn()) return

  // The websocket token expires after a minute, so a token fetched once would
  // make every reconnect after that fail authentication, and socket.io does
  // not retry a connection the server refused. As a function, auth runs
  // before every connection attempt, reconnects included.
  this.$socket.client.auth = callback => {
    useJwt
      .fetchWebsocketToken()
      .then(response => callback({ token: response.data.accessToken }))
      .catch(error => {
        console.error('Error fetching websocket token', error)
        callback({})
      })
  }
  this.$socket.client.open()
}
